<template>
  <el-form-item ref="rcDate" :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" @mouseenter.stop.native="controlMouseOver(component, index)"
                @click.native="controlClick(component, index)" :prop="getProp" :rules="rules"
                class="date-form-item rc-date-run" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName" :title="component.name"
                :label-width="labelParameter.width">
    <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{ labelParameter.labelName }}</div>
    <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain"
                :content="component.properties.componentExplain" placement="bottom-start">
      <span class="fa fa-question-circle"></span>
    </el-tooltip>
    <el-date-picker v-if="component.archive.dataType==='date'"
                    :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
                    :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
                    :value="tempValue" @input="setValue" :title="tempValue" @keydown.enter.exact.stop.native="getToday"
                    @change="updateValue" value-format="yyyy-MM-dd" type="date"
                    :disabled="disabled || component.properties.readonly" :picker-options="pickerOptions"
                    :placeholder="placeholder" @focus="controlClick(component, index)">
    </el-date-picker>
    <el-time-picker v-if="component.archive.dataType==='time'"
                    :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
                    :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
                    :value="tempValue" @input="setValue" :title="tempValue" @keydown.enter.exact.stop.native="getToday"
                    @change="updateValue" value-format="HH:mm:ss" arrow-control=""
                    :disabled="disabled || component.properties.readonly" :picker-options="{ selectableRange: selectableRangeStart }"
                    :placeholder="placeholder" @focus="controlClick(component, index)">
    </el-time-picker>
    <el-date-picker v-if="component.archive.dataType==='dateTime'"
                    :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
                    :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
                    :value="tempValue" @input="setValue" :title="tempValue" @keydown.enter.exact.stop.native="getToday"
                    @change="updateValue" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    :disabled="disabled || component.properties.readonly" :picker-options="pickerOptions"
                    :placeholder="placeholder" @focus="controlClick(component, index)">
    </el-date-picker>
  </el-form-item>
</template>

<script>
import { componentMixin, inputMixin, relFunMixin, calculationMixin, defaultValueMixin } from './mixins'
import moment from 'moment'

export default {
  name: 'rc-date',
  mixins: [ componentMixin, inputMixin, relFunMixin, calculationMixin, defaultValueMixin ],
  props: ['component', 'value', 'disabled', 'labelParameter', 'index', 'tableCtrlKey'],
  data () {
    return {
      tempValue: this.value,
      selectData: {}
    }
  },
  methods: {
    setValue (val) {
      this.tempValue = val
    },
    getToday () {
      if (this.tempValue === '' || this.tempValue === null) {
        let today = new Date()
        if (this.component.archive.dataType === 'date') {
          this.tempValue = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
        } else if (this.component.archive.dataType === 'dateTime') {
          this.tempValue = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
        } else {
          this.tempValue = today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds()
        }
      }
    },
    updateValue (e) {
      if (this.component.archive.enable) {
        e === null ? this.update('') : this.update(e)
        this.$nextTick(() => this.$refs.rcDate.validate('blur'))
      }
      // 触发值改变事件
      this.$nextTick(() => this.executeFunctions('change'))
    }
  },
  computed: {
    placeholder () {
      if (this.component.properties.placeholder) {
        return this.component.properties.placeholder
      }
      switch (this.component.archive.dataType) {
        case 'date':
          return '请输入日期'
        case 'time':
          return '请输入时间'
        case 'dateTime':
          return '请输入日期时间'
      }
    },
    // 时间区间开始要禁用的区域
    selectableRangeStart () {
      const {startData, endData} = this.selectData
      const start = startData ? moment(new Date(startData)).format('HH:mm:ss') : '00:00:00'
      const end = endData ? moment(new Date(endData)).format('HH:mm:ss') : '23:59:59'
      return `${start}-${end}`
    }
  },
  watch: {
    'value' (val) {
      if (this.tempValue !== val) {
        this.tempValue = val
      }
    },
    tempValue (val) {
      if (val && typeof val === 'string' && this.component.archive.dataType === 'time' && val.length < 6) {
        this.tempValue = val + ':00'
      }
    }
  },
  async created () {
    // 获取开始/结束时间计算结果
    this.selectData = await this.getStartAndEndDate()
  }
}
</script>
<style lang="scss">
  .date-form-item .el-form-item__content {
    >div.el-input {
      width: 100%;
    }
  }

  .date-form-item.hidden .el-form-item__content {
    margin-left: 0px !important;
    >div.el-input {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-date.vue